export default __webpack_public_path__ + "static/aml-d4698497c1c4ee354639f41c4683a40f.png";